import { SortingState } from '@tanstack/react-table';
import { useCallback, useMemo, useState } from 'react';

type UseTableControlsOptions = {
  initialPage?: number;
  initialSorting?: SortingState;
  onPageChange?: (nextPage: number) => void;
  onSortingChange?: (nextSorting: SortingState) => void;
};

const useTableControls = (options?: UseTableControlsOptions) => {
  const [page, setPageState] = useState(options?.initialPage ?? 1);
  const [sorting, setSortingState] = useState<SortingState>(
    options?.initialSorting ?? [],
  );

  const setPage = useCallback(
    (value: number | ((prev: number) => number)) => {
      setPageState((prevPage) => {
        const nextPage = typeof value === 'function' ? value(prevPage) : value;
        options?.onPageChange?.(nextPage);
        return nextPage;
      });
    },
    [options],
  );

  const setSorting = useCallback(
    (value: SortingState | ((prev: SortingState) => SortingState)) => {
      setSortingState((prevSorting) => {
        const nextSorting =
          typeof value === 'function' ? value(prevSorting) : value;
        options?.onSortingChange?.(nextSorting);
        return nextSorting;
      });
    },
    [options],
  );

  const sortField = useMemo(() => sorting[0]?.id || '', [sorting]);
  const sortOrder = useMemo(
    () => (sorting[0]?.desc ? 'desc' : 'asc'),
    [sorting],
  );

  return {
    page,
    setPage,
    sorting,
    setSorting,
    sortField,
    sortOrder: sortOrder as 'asc' | 'desc',
  };
};

export default useTableControls;
